import {
  BackgroundAnimationOverlay,
  Navbar,
  PageContainer,
  PageProviders,
  PushDrawerContainer,
  StageContainer,
} from "../../components";
import { useRebrand } from "@growtherapy/sprout-ui";
import { PushDrawerWrapper as PushDrawer } from "../PushDrawer";
import { Theme } from "../../state";
import { useParams } from "react-router-dom";
import { useGetTelehealthSessionInfo } from "../../hooks";
import {
  PageContent,
  PageContentWrapperProps,
} from "./page-content/PageContent";
import { FC } from "react";
import { INTRO_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from "../constants";

interface PageProps {
  pageContentComponent: FC<PageContentWrapperProps>;
}

export function Page({
  pageContentComponent: PageContentComponent,
}: PageProps) {
  const isRebrand = useRebrand();

  return (
    <>
      <PageProviders theme={Theme.LIGHT}>
        <PageContainer>
          {!isRebrand && <BackgroundAnimationOverlay autoplay={false} />}
          <div className="relative flex flex-col h-full w-full">
            <Navbar />
            <PushDrawerContainer>
              <StageContainer className="bg-transparent overflow-auto sm:py-12 justify-normal">
                <PageContentComponent
                  drawerId={INTRO_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
                />
              </StageContainer>
              <PushDrawer
                className="sm:my-2 sm:h-auto"
                id={INTRO_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
              />
            </PushDrawerContainer>
          </div>
        </PageContainer>
      </PageProviders>
    </>
  );
}

export function PageWrapper() {
  const { providerShortId, patientShortId } = useParams();
  useGetTelehealthSessionInfo(providerShortId, patientShortId);

  return <Page pageContentComponent={PageContent} />;
}
